import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import * as actions from "../../actions";
import PropTypes from 'prop-types';
import { Button, Tabs, message,Icon } from 'antd';
import CustomerForm from './CustomerForm';
import ExecuteShipment from './ExecuteShipment';
import ShipperInfoForm from './ShipperInfoForm';
import SignUp from './SignUp';
import BookViaAgent from './BookViaAgent';

const { TabPane } = Tabs;


class CustomerExecuteShipmentTabs extends Component {
  state = {
    activeKey: '1',
    formSubmitted: false,
    selectedCard: null,
    formData: {},
  };

  handleTabChange = (key) => {
    if (key === '2' && !this.state.formSubmitted) {
      message.warning('Please submit the customer form first.');
      return;
    }
    this.setState({ activeKey: key });
  };

  handleFormSubmit = () => {
    this.setState({ formSubmitted: true, activeKey: '2' });
  };

  handleCardSelect = (cardType) => {
    this.setState({ selectedCard: cardType, activeKey: '3' });
  };

  handleValuesChange = (changedFields) => {
    console.log('.... changedFields ............', changedFields);
    this.setState((prevState) => ({
      formData: { ...prevState.formData, ...changedFields },
    }));
  };

  renderSelectedTab = () => {
    const { selectedCard } = this.state;
    const { history } = this.props; // Access history from props
    switch (selectedCard) {
      // case 'BookAndPay':
      case 'BookNow':
        return <ShipperInfoForm />
      case 'Signup':
        return  <SignUp /> 
      case 'BookThroughAgent':
        //history.push('/agent'); // Navigate to /agent page
        //return null; // Do not render anything since the user is redirected
        return <BookViaAgent/>
      default:
        return null;
    }
  };

  handleGoBack = () => {
    //window.history.back();
    this.props.public_user_submit_button(false);
    //this.props.back_submit_button(true)
  };

  render() {
    const { selectedCard } = this.state;

    const operations =  <Button type="default" style={{marginRight:"1rem"}}
      onClick={this.handleGoBack}>
      <Icon type="arrow-left"/>
      Back to Search
    </Button>;
    
    return (
      <div style={{backgroundColor:'white'}}>
        <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange} tabBarExtraContent={operations}>
          <TabPane tab={
             <span>
              <Icon type="user" />
              Customer
            </span>
            } 
            key="1">
          <CustomerForm onSubmit={this.handleFormSubmit} onChange={this.handleValuesChange}/>
           </TabPane>
          <TabPane tab={<span><Icon type="code-sandbox" /> 
             Execute Shipment</span>} key="2">
            <ExecuteShipment onCardSelect={this.handleCardSelect}  />
          </TabPane>
          {selectedCard && (
            <TabPane tab={<span><Icon type="form" />{selectedCard.replace(/([A-Z])/g, ' $1')}</span>} key="3">
              {this.renderSelectedTab()}
            </TabPane>
          )}
        </Tabs>
      </div>
    );
  }
}


CustomerExecuteShipmentTabs.propTypes = {
  discount: PropTypes.object,
  queryParams: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
     
      queryParams: state.route.queryParams,
      discount: state.route.discount,
      final_search_form:state.route.final_search_form,
      transactionType: state.code_config.transactionType,
  };
};
export default withRouter(connect(mapStateToProps, actions)(CustomerExecuteShipmentTabs));